export default "__VITE_ASSET__CJ8Nvw3L__"